import { Controller } from "@hotwired/stimulus"

// Refreshes the order result page while the webhook has not confirmed the payment yet.
// The page itself renders the status; this only re-requests it, a bounded number of times.
export default class extends Controller {
  static values = { interval: { type: Number, default: 3000 }, maxAttempts: { type: Number, default: 40 } }

  connect() {
    const url = new URL(window.location.href)
    const attempt = Number(url.searchParams.get("poll") || 0)
    if (attempt >= this.maxAttemptsValue) return

    this.timer = setTimeout(() => {
      url.searchParams.set("poll", attempt + 1)
      window.Turbo.visit(url.toString(), { action: "replace" })
    }, this.intervalValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
